import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Grid, Typography, Container, Stack } from "@mui/material";

export default function BlogDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    console.log(slug)
    fetch("/blog.json")
      .then((res) => res.json())
      .then((data) => {
        
        const foundPost = data.find((item) => item.link === `/blog/${slug}`);
        setPost(foundPost);
      });
  }, [slug]);

  if (!post) return <Typography mt='15%'>Ladataan...</Typography>;

  return (

    <Container maxWidth="md" sx={{ mt: '10%' }}>
      <Grid container spacing={2} alignItems="center">
        {/* Başlık */}
        <Grid item xs={12} md={7}>
          <Typography component='h1' variant="h4" sx={{ fontWeight: "bold" }}>
            {post.title}
          </Typography>
        </Grid>
    
        {/* Görsel */}
        <Grid item xs={12} md={5}>
          <img
            src={post.image}
            alt={post.title}
            style={{
              width: "100%",
              height: "auto",
              borderRadius: 8,
            }}
          />
        </Grid>
      </Grid>
    
      {/* İçerik */}
      <Typography

        variant="body1"
        sx={{ whiteSpace: "pre-line", mt: 4 }}
      >
        {post.content}
      </Typography>
    </Container>
    
  );
}
